import React from 'react';
import { componentsRedux } from 'redux/reusable';
import { useTankLevelSubQuerys } from 'apollo/filter-tank-level';

const Subqueries = (props) => {
  const { yearStart, yearEnd, weekStart, weekEnd } = props;
  const { data, loading } = useTankLevelSubQuerys({
    yearStart,
    yearEnd,
    weekStart,
    weekEnd,
  });
  return <>{props.children({ loading, data: data.Subqueries })}</>;
};

export default componentsRedux(Subqueries);
